<ng-container
  *ngIf="isReadOnly || bindingFormControl?.readonly; else showInputSelect"
>
  <div sigvValueDiffItem="contractFormat" class="p-text-bold-500">
    {{
      bindingFormControl?.value
        | replaceNullWith : '-'
        | optionsMapping : selectOptions
    }}
  </div>
</ng-container>
<ng-template #showInputSelect>
  <sigv-form-control-widget
    [fieldName]="fieldName"
    [bindingFormControl]="bindingFormControl"
  >
    <p-dropdown
      sigvDropdownSetting
      placeholder=" {{
        (placeholder == undefined ? 'Please Select' : placeholder) | translate
      }}"
      [formControl]="bindingFormControl"
      [options]="selectOptions"
      [panelStyleClass]="useStyle"
      [showClear]="!forceCloseCleaner"
      appendTo="body"
      class="p-component-fluid"
      (onChange)="onChangeEvent($event)"
      (onParentChange)="onParentChangeEvent($event)"
    >
      <ng-template *ngIf="isShowRedSelectedItem" pTemplate="selectedItem">
        <span class="p-text-red">
          {{
            bindingFormControl?.getRawValue() | optionsMapping : selectOptions
          }}
        </span>
      </ng-template>
    </p-dropdown>
  </sigv-form-control-widget>
</ng-template>
